// Slow editorial marquee. Duplicated content for a seamless loop.
export const Marquee = ({
  items = ["Restore", "Recover", "Rejuvenate", "Perform"],
  tone = "gold",
}) => {
  const color =
    tone === "gold" ? "text-legacy-gold/30" : "text-legacy-mint/25";
  const sequence = [...items, ...items, ...items, ...items];
  return (
    <div
      className="marquee relative overflow-hidden border-y border-white/10 py-8 md:py-12"
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track">
        {sequence.map((item, i) => (
          <span
            key={i}
            className={`font-heading italic text-5xl md:text-7xl lg:text-8xl px-8 md:px-14 ${color}`}
          >
            {item}
            <span className="mx-8 md:mx-14 not-italic text-legacy-gold/20">•</span>
          </span>
        ))}
      </div>
    </div>
  );
};
